import { createLogger } from "utils/logging";
import { Cinema } from "../cinema-module/cinema";

const log = createLogger("cinema", "pdp");

export class PdpCinema {
	init() {
		/*                                                                                                 */
		const cinema = new Cinema();
		cinema.init(1);

		log.info("Initialize PdPCinema");
	}
}
